import { createContext, useContext } from 'react';
// What the chat's tools found, for the pages beside it. `startedBy`: the
// applications this conversation started (queue_job), as reply id → job ids.
export const PanelResultsContext = createContext({ panelCounts: {}, jobMatches: {}, choosePanel: () => {}, startedBy: new Map() });
export const usePanelResults = () => useContext(PanelResultsContext);
